import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import ExpensesCardGroup from 'assets/images/expenses-card-group.svg'
import FactorialRedVirtualPremiumCard from 'assets/images/factorial-red-virtual-premium-card.svg'

import i18n from 'modules/core/lib/i18n'

import CtaButtons from './CtaButtons'

export type CtaDescription = 'CREATE_ACCOUNT' | 'COMPLETE_ACCOUNT'
export const CtaDescription: Record<CtaDescription, CtaDescription> = {
  CREATE_ACCOUNT: 'CREATE_ACCOUNT',
  COMPLETE_ACCOUNT: 'COMPLETE_ACCOUNT',
}

export type CardsImage = 'SINGLE' | 'MULTIPLE'
export const CardsImage: Record<CardsImage, CardsImage> = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
}

interface CardsHeroProps {
  primaryButtonText?: string
  ctaDescription?: CtaDescription
  cardsImage?: CardsImage
  isDismissable: boolean
  onPrimaryButtonClick: () => void
  onSkipClick?: () => void
}

const CardsHero: React.FC<CardsHeroProps> = ({
  primaryButtonText = i18n.t('expenses_v2.cards.blocks.require_onboarding.get_my_cards_now'),
  ctaDescription = 'create_account',
  cardsImage = 'multiple',
  isDismissable,
  onPrimaryButtonClick,
  onSkipClick,
}) => {
  const showCompleteCardsCta = ctaDescription === CtaDescription.COMPLETE_ACCOUNT
  return (
    <Box paddingX="s64" paddingY="s48" width="full" flexDirection="column" gap="s32">
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Box gap="s32">
          <Box gap="s12">
            <Box width="fit-content">
              <Tag leftItem="circle" showCircle type={showCompleteCardsCta ? 'champagne' : 'lime'}>
                {showCompleteCardsCta
                  ? i18n.t('expenses_v2.cards.blocks.hero_section.tag_status.incomplete')
                  : i18n.t('expenses_v2.cards.blocks.hero_section.tag_status.not_started')}
              </Tag>
            </Box>
            <Box gap="s6" maxWidth="s400">
              <Text.Header1 htmlTag="h1">
                {showCompleteCardsCta
                  ? i18n.t(
                      'expenses_v2.cards.blocks.hero_section.account_creation_title.incomplete'
                    )
                  : i18n.t(
                      'expenses_v2.cards.blocks.hero_section.account_creation_title.not_started'
                    )}
              </Text.Header1>
              <Text.Normal>
                {showCompleteCardsCta
                  ? i18n.t(
                      'expenses_v2.cards.blocks.hero_section.account_creation_subtitle.incomplete'
                    )
                  : i18n.t(
                      'expenses_v2.cards.blocks.hero_section.account_creation_subtitle.not_started'
                    )}
              </Text.Normal>
            </Box>
          </Box>
          <Box flexDirection="column" gap="s8">
            <Box width="fit-content">
              <CtaButtons
                primaryButtonText={primaryButtonText}
                isDismissable={isDismissable}
                onPrimaryButtonClick={onPrimaryButtonClick}
                onSkipClick={onSkipClick}
              />
            </Box>
          </Box>
        </Box>
        <Box>
          {cardsImage === CardsImage.SINGLE ? (
            <img src={FactorialRedVirtualPremiumCard} height="100%" width="100%" />
          ) : (
            <img width="100%" height="100%" src={ExpensesCardGroup} role="presentation" />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default CardsHero
